import React from 'react';
export function PhotoCollage() {
  const photos = [{
    src: 'https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    rotate: '-rotate-6'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/m853YPtgHVvwabhJvDgm8N/marriage-pose-photo-recirc-kyle-john-1-29-4f97523aa049471992292e8d6ddc41ee.jpg',
    rotate: 'rotate-3'
  }, {
    src: 'https://images.unsplash.com/photo-1520342868574-5fa3804e551c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    rotate: '-rotate-2'
  }, {
    src: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    rotate: 'rotate-6'
  }];
  return <section className="bg-[#FFC4D0] py-24 px-4 md:px-8 overflow-hidden" data-id="element-147">
      <div className="container mx-auto" data-id="element-148">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-149">
          {photos.map((photo, index) => <div key={index} className={`transform ${photo.rotate} hover:rotate-0 transition-all duration-500 hover:z-10 hover:scale-110`} data-id="element-150">
              <div className="bg-white p-3 pb-12 shadow-xl" data-id="element-151">
                <img src={photo.src} alt={`Memory ${index + 1}`} className="w-full aspect-square object-cover bg-gray-100" data-id="element-152" />
                <div className="mt-4 font-['Caveat'] text-xl text-gray-600 text-center" data-id="element-153">
                  {['Love', 'Memories', 'Forever', 'Joy'][index]}
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-16 max-w-2xl mx-auto" data-id="element-154">
          <p className="text-xl md:text-2xl font-['Caveat'] text-gray-800 leading-relaxed" data-id="element-155">
            "The audio guest book was the highlight of our reception. Listening
            to our grandparents' voices now is something we'll cherish forever."
          </p>
        </div>
      </div>
    </section>;
}